<template>
  <PropertyOnboardingStep
    title="Set your availability"
    :is-next-button-disabled="false"
    :next-button-text="'Create Listing'"
    :submit="submit"
  >
    <View direction="column" gap="xl">
      <Text variant="body-medium" color="secondary" align="start">
        Set up the property availability and Tallo will only propose showings during the times you are available
      </Text>
      <PropertyAvailability />
    </View>
  </PropertyOnboardingStep>
</template>

<script setup lang="ts">
import { Text, View } from '@tallo/design-system';
import { usePropertyStore } from '@tallo/investor/property';
import { PropertyStatus } from '@tallo/property';

import PropertyAvailability from '../../../property/pages/availability/property-availability.vue';
import PropertyOnboardingStep from '../property-onboarding-step.vue';

const propertyStore = usePropertyStore();

async function submit() {
  await propertyStore.saveStatus(PropertyStatus.READY_FOR_LISTING);
}
</script>
